import React, {FC, useEffect, useState} from "react";
import {Breadcrumb, Table} from "react-bootstrap";
import {Helmet} from "react-helmet";
import {TextDiv, useLoader, useMessage} from "backoffice/ui/Components";
import {useTRPC} from "backoffice/ui/App.tsx";
import {useSearchParams} from "react-router-dom";
import {AppRouterOutput} from "backoffice/api/AppRouter";
import {FundStatus} from "src/codes";


export const FundCoolingPage: FC = () => {
  const today = new Date();

  const Loader  = useLoader(),
        Message = useMessage(),
        tRPC    = useTRPC();

  const [query]           = useSearchParams(),
        [funds, setFunds] = useState<AppRouterOutput['fund']['coolingOff']['list']>({});

  const date = query.get('date'),
        days = Math.min(Number(query.get('days')?.toNumber() ?? 7), 14);

  useEffect(() => {
    const request = {date, days};
    Loader.task(async () => tRPC.fund.coolingOff.list.query(request), 500)
          .then(result => setFunds(result))
          .catch(err => {
            console.error(err);
            Message.error(err);
          });

  }, [query.toString()]);

  const list   = Object.values(funds),
        _hdays = Array(days).fill(0),
        _ddays = Array(days + 1).fill(0);

  return (
      <>
        <Helmet>
          <title>クーリング・オフ状況</title>
        </Helmet>

        <div className={'container'}>
          <Breadcrumb>
            <Breadcrumb.Item active>ファンド管理</Breadcrumb.Item>
            <Breadcrumb.Item active>クーリングオフ状況</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className={'container small'}>
          <Table hover>
            <thead>
            <tr>
              <th className='text-center' rowSpan={2}>ファンドID</th>
              <th className='text-start ' rowSpan={2}>ファンド名</th>
              <th className='text-start ' rowSpan={2}>主案件</th>
              <th className='text-center' rowSpan={2}>状況</th>
              <th className='text-center' rowSpan={2}>運用開始日</th>
              <th className='text-end   ' rowSpan={2}>運用可能額</th>
              <th className='text-center' colSpan={days + 1}>クーリング・オフ可能額</th>
            </tr>
            <tr>
              <th className={'text-right'}>{today.toYmd()}</th>
              {_hdays.map((_, index) => <th key={index} className={'text-end'}>+{index + 1}日</th>)}
            </tr>
            </thead>

            <tbody>
            {list.length === 0 && (<tr>
              <td colSpan={12}>no data</td>
            </tr>)}
            {list.map(({fund, current, coLimits}) => (
                <tr key={`${fund.item_id}-${date}-${days}`}>
                  <td className={'text-center'}>{fund.item_id}</td>
                  <td className={'text-start '}><TextDiv width={'7rem'}>{fund.item_name}</TextDiv></td>
                  <td className={'text-start '}><TextDiv width={'7rem'}>{fund.project_name}</TextDiv></td>
                  <td className={'text-center'}>{FundStatus.find(fund.status_code).value}</td>
                  <td className={'text-center'}>{fund.activate_date}</td>
                  <td className={'text-end   '}>{current.withComma}</td>
                  {_ddays.map((_, index) => <td key={index} className={'text-end'} style={{minWidth: '5rem'}}>{coLimits[index]?.withComma}</td>)}
                </tr>
            ))}
            </tbody>
          </Table>
        </div>
      </>
  );
}
